module.exports = __webpack_public_path__ + "static/img/boron-2.822c5e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/boron-2.jpg
// module id = rEOy
// module chunks = 1